<template>
	<el-card class="box-card">
		<div slot="header" class="clearfix">
			<span>门店信息</span>
			<span>
				<el-button v-if="store.store_state==1" type="success"  plain size="mini" icon="el-icon-success">已认证</el-button>
			</span>
		</div>
		<div style="min-height: calc(100vh - 210px);background-color: white;display: flex;align-content: space-between;flex-wrap: wrap;">
			<el-form  ref="form" :model="store" label-position="left" label-width="auto" :inline="true" style="width: 100%;">
				<el-form-item label="门店名称">
					<el-input v-model="store.store_name"></el-input>
				</el-form-item>
				<el-form-item label="负责人">
					<el-input v-model="store.store_man"></el-input>
				</el-form-item>
				<el-form-item label="负责人电话">
					<el-input v-model="store.store_tel"></el-input>
				</el-form-item>
				<el-form-item label="紧急联系电话">
					<el-input v-model="store.store_tel2"></el-input>
				</el-form-item>
				<el-form-item label="门店地址">
					<el-input v-model="store.store_address"></el-input>
				</el-form-item>
				<el-form-item label="支付宝账号">
					<el-input disabled v-model="store.alipay_login_user"></el-input>
				</el-form-item>
				<el-form-item label="申请时间">
					<el-input disabled v-model="store.store_addDate"></el-input>
				</el-form-item>
				<el-form-item label="认证时间">
					<el-input disabled v-model="store.store_authDate"></el-input>
				</el-form-item>
				<el-form-item label="门店状态">
					<el-input disabled v-model="store.store_state==0?'未认证':'已认证'"></el-input>
				</el-form-item>
				<el-form-item label="账号余额">
					<el-input disabled v-model="store.store_account"></el-input>
				</el-form-item>
				<br />
				<el-form-item label="营业执照">
					<div>
						<el-image :lazy="true" style="width: 100px; height: 100px" :src="host+store.store_license_img" :preview-src-list="[host+store.store_license_img]"></el-image>
						<el-upload class="upload-demo" :action="host+'/store/upload'" :on-success="onSuccesslicense_img" :limit="1" :data="{dir:'store'}">
							<el-button  size="mini" type="text">替换</el-button>
						</el-upload>
					</div>
				</el-form-item>
				<el-form-item label="法人身份证">
					<el-image style="width: 100px; height: 100px" :src="host+store.store_idcard_img" :preview-src-list="[host+store.store_idcard_img]"></el-image>
					<el-upload class="upload-demo" :action="host+'/store/upload'" :on-success="onSuccessstore_idcard_img" :limit="1"
					 :data="{dir:'store'}">
						<el-button  size="mini" type="text">替换</el-button>
					</el-upload>
				</el-form-item>
				<el-form-item label="门店logo">
					<el-image style="width: 100px; height: 100px" :src="host+store.store_logo" :preview-src-list="[host+store.store_logo]"></el-image>
					<el-upload class="upload-demo" :action="host+'/store/upload'" :on-success="onSuccessstore_logo" :limit="1" :data="{dir:'store'}">
						<el-button  size="mini" type="text">替换</el-button>
					</el-upload>
				</el-form-item>
				<el-form-item label="门店图片">
					<el-image style="width: 100px; height: 100px" :src="host+store.store_img" :preview-src-list="[host+store.store_img]"></el-image>
					<el-upload class="upload-demo" :action="host+'/store/upload'" :on-success="onSuccessstore_img" :limit="1" :data="{dir:'store'}">
						<el-button  size="mini" type="text">替换</el-button>
					</el-upload>
				</el-form-item>
			</el-form>
			<div style="width: 100%;display: flex;justify-content: center;padding-top: 30px;">
				<el-button style="width: 200px;" v-if="store.store_state==1" type="danger" @click="updateState(0)">取消认证</el-button>
				<el-button style="width: 200px;" v-if="store.store_state==0" type="success" @click="updateState(1)">通过认证</el-button>
				<el-button style="margin-left: 50px;width: 200px;" type="primary" @click="updateStore">保存修改</el-button>
			</div>
		</div>
	</el-card>
</template>

<script>
	export default {
		data() {
			return {
				store: {},
				store_id: ''
			}
		},
		mounted() {
			var that=this;
			this.store_id = this.$route.query.store_id;
			setTimeout(function(){
				that.getData();
			},500);
		},
		methods: {
			updateStore() {
				var that = this;
				that.$axios.post('zuche/admin/updateStore', that.store).then(function(res) {
					if (res.data.success) {
						that.$message.success('修改成功');
						that.getData();
					} else {
						that.$message.error(res.data.message);
					}
				});
			},
			updateState(state) {
				var that = this;
				var title = state == 1 ? '确定通过认证吗？' : '确定取消认证吗？';
				this.$confirm(title, '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '考虑以下',
					type: 'warning'
				}).then(() => {
					that.store.store_state = state;
					that.$axios.post('zuche/admin/updateStore', that.store).then(function(res) {
						if (res.data.success) {
							that.getData();
						} else {
							that.$message.error(res.data.message);
						}
					});
				})
			},
			onSuccesslicense_img(res, file) {
				this.store.store_license_img = res.result;
			},
			onSuccessstore_idcard_img(res, file) {
				this.store.store_idcard_img = res.result;
			},
			onSuccessstore_logo(res, file) {
				this.store.store_logo = res.result;
			},
			onSuccessstore_img(res, file) {
				this.store.store_img = res.result;
			},
			getData() {
				var that = this;
				this.$axios.post('zuche/admin/getStoreList', {
					store_id: this.store_id
				}).then(function(res) {
					console.log(res);
					if (res.data.success) {
						that.store = res.data.result.stores[0];
						that.store.store_addDate = that.timeFormat(that.store.store_addDate);
						that.store.store_authDate = that.timeFormat(that.store.store_authDate);
					} else {
						that.$message.error(res.data.message);
					}
				});
			}
		}
	}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/storeInfo.vue